"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _PostEditor = _interopRequireDefault(require("@insided/shared/uikit/PostEditor"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PageUnloadContext = require("@insided/shared/services/PageUnloadContext");

var _GroupJoin = _interopRequireDefault(require("@insided/deprecated-preact-components/groups-destination/GroupJoin"));

var _utils = require("@insided/deprecated-preact-components/editor/utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'topic-add-reply';
exports.cssAnchorName = cssAnchorName;

var TopicAddReply = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicAddReply, _Component);

  var _super = _createSuper(TopicAddReply);

  function TopicAddReply() {
    var _this;

    (0, _classCallCheck2.default)(this, TopicAddReply);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      content: ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (content) {
      _this.setState({
        content: content
      });
    });
    return _this;
  }

  (0, _createClass2.default)(TopicAddReply, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          topicId = _this$props.topicId,
          isGuest = _this$props.isGuest,
          type = _this$props.type,
          disableFileAttachments = _this$props.disableFileAttachments,
          _this$props$redirect = _this$props.redirect,
          redirect = _this$props$redirect === void 0 ? false : _this$props$redirect,
          showGroupJoin = _this$props.showGroupJoin,
          placeholder = _this$props.placeholder;
      var content = this.state.content;
      return (0, _preact.h)(_PageUnloadContext.PageUnloadContext.Consumer, null, function (_ref) {
        var lock = _ref.lock,
            unlock = _ref.unlock;
        return (0, _preact.h)("div", {
          className: (0, _classnames.default)('box__content', 'qa-reply', 'reply-editor-wrapper')
        }, (0, _preact.h)("h3", null, (0, _preact.h)(_phrase.default, {
          p: "editor.title.comment"
        })), (0, _preact.h)("br", null), showGroupJoin && (0, _preact.h)(_GroupJoin.default, {
          publicGroupMessage: true
        }), (0, _preact.h)(_PostEditor.default, {
          type: type,
          disableFileAttachments: disableFileAttachments,
          topicId: topicId,
          profile: "nonthreaded-reply",
          replyId: null,
          isControl: false,
          onSuccess: function onSuccess() {
            window.location.reload();
          },
          redirect: redirect,
          isGuest: isGuest,
          onChange: function onChange(content) {
            lock(content);

            _this2.onChange(content);
          },
          data: content,
          submitRequest: function submitRequest(props) {
            var _props$replyId;

            unlock();
            return type !== 'productUpdate' && type !== 'idea' ? (0, _utils.determineRequest)({
              postId: (_props$replyId = props.replyId) !== null && _props$replyId !== void 0 ? _props$replyId : 0,
              topicId: props.topicId,
              isControl: props.isControl
            }) : undefined;
          },
          placeholder: placeholder
        }));
      });
    }
  }]);
  return TopicAddReply;
}(_preact.Component);

var _default = TopicAddReply;
exports.default = _default;